export const PAYMENT_OPTIONS_URL = '/pages/subscription-v3/payment-options';
